import React, { useState } from "react";
import Slider from "react-slick";
import car1 from "../../assets/assets/images/car_detail/car_detail_main.png";
import car2 from "../../assets/assets/images/car_detail/more_image_car1.png";
import car3 from "../../assets/assets/images/car_detail/more_image_car2.png";
import car4 from "../../assets/assets/images/car_detail/more_image_car3.png";
import car5 from "../../assets/assets/images/car_detail/more_image_car4.png";
import { useSelector } from "react-redux";

export default function SyncSlider({ sliderImages }) {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [nav1, setNav1] = React.useState(null);
  const [nav2, setNav2] = React.useState(null);
  let slider1 = [];
  let slider2 = [];

  React.useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <div>
      <Slider
        asNavFor={nav2}
        ref={(slider) => (slider1 = slider)}
        className="mainImg"
      >
        {/* <div className='p-2'  >
                    <img src={car1} className='img-fluid detail-img' />
                </div>
                <div className='p-2'  >
                    <img src={car2} className='img-fluid detail-img' />
                </div>
                <div className='p-2'  >
                    <img src={car3} className='img-fluid detail-img' />
                </div>
                <div className='p-2'  >
                    <img src={car4} className='img-fluid detail-img' />
                </div>
                <div className='p-2'  >
                    <img src={car5} className='img-fluid detail-img' />
                </div> */}

        {sliderImages?.map((img, index) => {
          return (
            <div className="p-2" key={index}>
              <img src={`${baseURL}${img}`} className="img-fluid detail-img" />
            </div>
          );
        })}
      </Slider>
      <Slider
        asNavFor={nav1}
        ref={(slider) => (slider2 = slider)}
        slidesToShow={3}
        swipeToSlide={true}
        focusOnSelect={true}
        className="slider-img"
      >
        {sliderImages?.map((img, index) => {
          return (
            <div
              key={"carDetails" + index}
              className="p-2 d-flex justify-content-center align-items-center"
            >
              <img src={`${baseURL}${img}`} className="img-fluid img-slick" />
            </div>
          );
        })}
        {/* <div className='p-2 d-flex justify-content-center align-items-center'  >
                    <img src={car1} className='img-fluid' />
                </div>
                <div className='p-2 d-flex justify-content-center align-items-center'  >
                    <img src={car2} className='img-fluid' />
                </div>
                <div className='p-2 d-flex justify-content-center align-items-center'  >
                    <img src={car3} className='img-fluid' />
                </div>
                <div className='p-2 d-flex justify-content-center align-items-center'  >
                    <img src={car4} className='img-fluid' />
                </div>
                <div className='p-2 d-flex justify-content-center align-items-center'  >
                    <img src={car5} className='img-fluid' />
                </div> */}
      </Slider>
    </div>
  );
}
